<template>
	<div class="popup-message" :class="'popup-'+type">
	  <div class="pop-view">
		<div class="pop-icon" :class="'i'+type"><i :class="'el-icon-'+type"></i></div>
		<span class="pop-title">{{ this.title || $t('control.tip')}}</span>
		<p class="pop-content" v-if="this.msg">{{ this.msg }}</p>
		<div class="pop-btn" v-if="button">
		  <el-button type="primary" class="save" @click="closeMessage">{{$t('control.tip')}}</el-button>
		</div>
		<!-- <i class="delete" @click="closeMessage"></i> -->
	  </div>
	</div>
  </template>
   
  <script>
   
  export default {
	name: 'PopupMessage',
	data() {
	  return {
		callback: null,
		title: '',
		type: 'info',
		msg: '',
		button: true,
		duration: 0
	  };
	},
	methods: {
	  getParams(options) {
		this.callBack = options.callBack;
		this.type = options.type || 'info'
		this.title = options.title || ''
		this.msg = options.msg || ''
		this.button = options.button || true
		this.duration = options.duration || 0
   
		this.changePosition()
		// if(this.duration > 0){
		//   window.setTimeout(() => {
   
		// 	this.$destroy(true)
		// 	if(this.$el.parentNode){ // 当前节点是否已经被手动移除
		// 	  this.$el.parentNode.removeChild(this.$el)
		// 	}
   
		// 	this.changePosition()
		//   }, this.duration)
		// }
	  },
	  changePosition() {
		let doc = document.body.getElementsByClassName('popup-message')
		let sum = 0;
		for(let i=0; i< doc.length; i++){
		  this.$nextTick(() => {
			if(i>0){
			  sum = sum + document.body.getElementsByClassName('popup-message')[i-1].clientHeight + 5
			  document.body.getElementsByClassName('popup-message')[i].style = `top: ${sum}px`
			}else{
			  document.body.getElementsByClassName('popup-message')[i].style = `top: 0`
			}
		  })
		   
		}
	  },
	  closeMessage(){
		this.$destroy(true)
		this.$el.parentNode.removeChild(this.$el)
		this.changePosition()
	  }
	  
	},
	mounted() {
	},
  };
  </script>
  <style lang="less" scoped>
  .popup-message {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow: auto;
	margin: 0;
	z-index: 9999;
	background:rgba(0,0,0,.5);
	display:flex;
	align-items:center;
	justify-content:center;
	.pop-view{
	  width:440px;
	  min-height:250px;
	  background-color:#fff;
	  border-radius:5px;
	  display:flex;
	  align-items:center;
	  justify-content:center;
	  flex-direction: column;
	  padding:20px 30px;
	  box-sizing:border-box;
	  .pop-icon{
		color:#909399;
		font-size:50px;
		&.isuccess{
			color:#52c41a;
		}
		&.iwarning{
			color:#e6a23c;
		}
		&.ierror{
			color:#e7542f;
		}
	  }
	  .pop-title{
		display: block;
		font-size: 18px;
		font-weight: 600;
		padding: 10px 10px 25px;
		color:#1d2129;
	  }
	  .pop-content{
		font-weight: 400;
		font-size: 14px;
		padding: 0 10px 20px;
		line-height: 1.6;;
		margin: 0;
		color:#86909c;
	  }
	  .pop-btn{
		display: flex;
		justify-content: center;
		.save{
		  margin: 0;
		}
	  }
	}
  }
  </style>